/**
 * Demo data for the product windows. Every label matches the real Statio app
 * (apps/web in ../Pugio); every name is illustrative and pages that show these
 * say so. Change the data here and every window on the site follows.
 */

export type ToolState = 'via-server' | 'denied' | 'granted';

export interface ToolRow {
  name: string;
  state: ToolState;
  /** Numbered annotation shown next to the name (explainer only). */
  note?: number;
}

export const MANAGE_ACCESS = {
  principal: 'ci-agent',
  server: 'postgres',
  canInvoke: 'Yes',
  directGrant: 'Yes',
  teamAccess: 'None',
  tools: [
    { name: 'db.selectRows', state: 'via-server' },
    { name: 'db.listTables', state: 'via-server' },
    { name: 'db.deleteRows', state: 'denied' },
    { name: 'db.describeTable', state: 'via-server' },
  ] as ToolRow[],
};

export interface AgentRow {
  name: string;
  status: 'active' | 'suspended' | 'revoked' | 'Needs attestation';
  lastUsed: string;
  expires: string;
}

export const AGENTS: AgentRow[] = [
  { name: 'ci-agent', status: 'active', lastUsed: '2 min ago', expires: 'Jan 4, 2027' },
  { name: 'support-bot', status: 'active', lastUsed: '1 h ago', expires: 'Mar 1, 2027' },
  { name: 'nightly-sync', status: 'suspended', lastUsed: '3 days ago', expires: 'Nov 30, 2026' },
  { name: 'old-scraper', status: 'revoked', lastUsed: 'Aug 12', expires: 'n/a' },
];

export interface ActivityRow {
  outcome: 'allowed' | 'failed';
  tool: string;
  server: string;
  ms: number;
  code: number;
  caller: string;
  error?: string;
}

export const ACTIVITY: ActivityRow[] = [
  {
    outcome: 'allowed',
    tool: 'db.selectRows',
    server: 'postgres',
    ms: 42,
    code: 200,
    caller: 'agent ci-agent · production',
  },
  {
    outcome: 'failed',
    tool: 'db.deleteRows',
    server: 'postgres',
    ms: 3,
    code: 403,
    caller: 'agent ci-agent · production',
    error: "You don't have permission to call tool 'db.deleteRows'",
  },
  {
    outcome: 'allowed',
    tool: 'issues.create',
    server: 'github',
    ms: 61,
    code: 200,
    caller: 'user alex@acme · production',
  },
];

export interface FleetRow {
  name: string;
  type: 'MCP' | 'Skill' | 'Plugin';
  member: string;
  client: string;
  status: 'Managed' | 'External';
}

export const FLEET: FleetRow[] = [
  { name: 'postgres', type: 'MCP', member: 'alex@acme', client: 'Cursor', status: 'Managed' },
  { name: 'github', type: 'MCP', member: 'dana@acme', client: 'Claude Code', status: 'Managed' },
  { name: 'internal-hr-api', type: 'MCP', member: 'sam@acme', client: 'Cursor', status: 'External' },
  { name: 'web-scraper', type: 'Skill', member: 'sam@acme', client: 'Claude Code', status: 'External' },
];
